import { memo } from 'react';

import { Icon } from '@Sage/hoi-poi-ui';

import ActivityDetailContainer from '../ActivityDetailContainer';

const WorkflowDetail = memo(({ activity }) => (
    <ActivityDetailContainer activity={activity} icon={<Icon name="workflow" noTabs={false} />}>
        workflow{/* {this.renderWorkFlowInformation()} */}
    </ActivityDetailContainer>
));

WorkflowDetail.displayName = 'WorkflowDetail';

export default WorkflowDetail;
